// Who the member is between account creation and the end of sign up. The
// screens pass it in the router state, which a refresh or a deep link drops,
// so it is kept here too. sessionStorage, not localStorage, so the email goes
// away with the tab.
//
// Every access is guarded: a browser with site data blocked throws on the
// first call, and sign up has to keep working there.
export type SignUpIdentity = {
  email?: string;
  userId?: string;
  firstName?: string;
  lastName?: string;
};

const STORAGE_KEY = 'sign_up_identity_session';

export function persistSignUpIdentity(identity: SignUpIdentity) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(identity));
  } catch {
    // Nothing to recover from. The flow still works from the router state,
    // and only a refresh loses the member's details.
  }
}

export function getStoredSignUpIdentity(): SignUpIdentity {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);

    return stored ? JSON.parse(stored) : {};
  } catch {
    // Blocked storage, or a value someone else wrote.
    return {};
  }
}

export function clearStoredSignUpIdentity() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Already unreadable, so there is nothing to clear.
  }
}
